import { put, takeEvery, select } from 'redux-saga/effects'
import {
    START_POST_UNIQUECOUPON_HOLDS_ERROR,
    START_POST_UNIQUECOUPON_HOLDS_DELETE
} from "../actions/actionUniqueCouponHolds";
import { deleteUniqueCouponHolds } from 'api'

async function fetchAsync(func, payload) {
    const response = await func(payload);
    if (response.status == 200) {
        return await response.json();
    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {
        throw await response.json();
    }
    else {
        throw new Error("Unable to perform Coupon Hold, response: " + response.statusText + " - " + response.status)
    }
}

function* DeleteUniqueCouponHolds(action) {
    try {
        let delCoupinRes = yield fetchAsync(deleteUniqueCouponHolds, '?CouponHoldRef=' + action.UniqueCOuponHoldRef);

    } catch (e) {
        yield put({ type: START_POST_UNIQUECOUPON_HOLDS_ERROR, error: e });
    }
}

export const sagaUniqueCouponHolds = [
    takeEvery(START_POST_UNIQUECOUPON_HOLDS_DELETE, DeleteUniqueCouponHolds)
];